/**
 * Статические дефолтные настройки Handsontable.
 *
 * Не используют React Context — конфиг никогда не меняется в runtime.
 * Импортируйте напрямую: import { HOT_DEFAULTS } from './hotDefaults';
 */

export interface HotDefaults {
  readonly licenseKey: string;
  readonly language: string;
  readonly themeName: string;
  readonly numericCulture: string;
  readonly dropdownMenuDefault: boolean | string[] | object;
  readonly filtersDefault: boolean;
  readonly contextMenuDefault: boolean | string[] | object;
}

export const HOT_DEFAULTS: HotDefaults = {
  licenseKey: 'non-commercial-and-evaluation',
  language: 'ru-RU',
  themeName: 'ht-theme-main',
  numericCulture: 'ru-RU',
  dropdownMenuDefault: ['filter_by_value', 'filter_by_condition', 'filter_action_bar'],
  filtersDefault: true,
  contextMenuDefault: ['cut', 'copy', 'clear_column'],
} as const;
